<script setup>
import { SCHOOL_TRIPS_HEADER, SCHOOL_CARD_CONTENT, SCHOOL_CONTACT_LINK } from '~/constant/schoolTourDetails'
import {assetCDN} from '~/helper/index.js'
import { computed } from 'vue'
import { DESKTOP, TABLET } from '~/constant/common'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

// Even-odd section background — page passes 'cream' | 'cream-deep' (default: none).
defineProps({
  bg: { type: String, default: '', validator: (v) => ['', 'cream', 'cream-deep'].includes(v) },
})

const ASSETS_CDN = assetCDN()
const generalStore = useGeneralInfoStore()

const windowWidth = computed(() => generalStore.generalData.windowWidth)

const cardGrid = computed(() => {
  if(windowWidth.value >= DESKTOP) return 'grid-template-columns-minmax4'
  if(windowWidth.value >= TABLET) return 'grid-template-columns-minmax2'
  return ''
})

</script>

<template>
  <div class='mb-80 school-trips-divider' :class="bg ? `bg-${bg}` : ''">
    <div class='container'>
      <h2 class="fs-40 fw-700 mb-fs-32 lh-52 mb-8 pt-100 tc">
        {{ SCHOOL_TRIPS_HEADER }}
      </h2>
      <div :class="['grid grid-gap-24 pt-60', cardGrid]">
        <a :href="`${SCHOOL_CONTACT_LINK}`"
           class='h-400 school-trip-card br-14 flex justify-start pa-20' target='_blank'
             v-for="(item, key) in SCHOOL_CARD_CONTENT(ASSETS_CDN)"
             :key="key" :style="`background-image: url('${item.image}')`">
          <span class='white db'>
            <span class='fw-900 fs-28 db' v-html='item.title'></span>
            <span class='fw-600 lh-28 fs-20 pt-10 db'>{{item.content}}</span>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped lang='scss'>
  .school-trip-card {
    background-size: cover;
  }
</style>
